module.exports = __webpack_public_path__ + "static/media/titanroofing.8e44d889.png";